module.exports = __webpack_public_path__ + "static/media/powered-by.7e93eb8f.PNG";